module.exports = __webpack_public_path__ + "img/casino-wm.a52491bb.jpg";